import { makeStyles, createStyles } from '../../components/withStyles';
import { Theme } from 'raydiant-elements/theme';

const useStyles = makeStyles((_: Theme) => {
  return createStyles({
    paper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
  });
});

export default useStyles;
